export default "__VITE_PUBLIC_ASSET__1801a0e5__"